import { Truck, Menu, X, Phone } from "lucide-react";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const NAV_LINKS = [
  { label: "Services", href: "#services", id: "nav-services" },
  { label: "How It Works", href: "#how-it-works", id: "nav-how" },
  { label: "Why NJI", href: "#why", id: "nav-why" },
  { label: "Contact", href: "#contact", id: "nav-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 border-b-[3px] border-black bg-white"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 md:px-8">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-3 group">
          <div className="flex h-11 w-11 items-center justify-center border-[3px] border-black bg-[#3B82F6] shadow-brutal-sm">
            <Truck className="h-6 w-6 text-white" strokeWidth={2.5} />
          </div>
          <div className="leading-none">
            <div className="font-display text-xl uppercase tracking-wide text-black">NJI Cleanouts</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-neutral-600">Hauling · Debris · Cleanouts</div>
          </div>
        </Link>

        {isHome && (
          <nav className="hidden items-center gap-6 md:flex">
            {NAV_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                data-testid={l.id}
                className="text-sm font-semibold uppercase tracking-wider text-black hover:text-[#3B82F6] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>
        )}

        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:+19733069206"
            data-testid="nav-phone-cta"
            className="flex items-center gap-2 border-[3px] border-black bg-black px-4 py-2 text-sm font-bold uppercase tracking-wider text-white shadow-brutal-sm btn-brutal-hover"
          >
            <Phone className="h-4 w-4" />
            (973) 306-9206
          </a>
          <a
            href="#quote"
            data-testid="nav-quote-cta"
            className="border-[3px] border-black bg-[#3B82F6] px-4 py-2 text-sm font-bold uppercase tracking-wider text-white shadow-brutal-sm btn-brutal-hover"
          >
            Get Free Quote
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden border-[3px] border-black p-2 shadow-brutal-sm"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t-[3px] border-black bg-white px-4 py-4">
          {isHome && (
            <nav className="flex flex-col gap-3 mb-4">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.label}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-sm font-semibold uppercase tracking-wider text-black"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          )}
          <a
            href="tel:+19733069206"
            className="mb-2 flex items-center justify-center gap-2 border-[3px] border-black bg-black px-4 py-3 text-sm font-bold uppercase tracking-wider text-white shadow-brutal-sm"
          >
            <Phone className="h-4 w-4" /> (973) 306-9206
          </a>
          <a
            href="#quote"
            onClick={() => setOpen(false)}
            className="flex items-center justify-center border-[3px] border-black bg-[#3B82F6] px-4 py-3 text-sm font-bold uppercase tracking-wider text-white shadow-brutal-sm"
          >
            Get Free Quote
          </a>
        </div>
      )}
    </header>
  );
}
